import './index.css'


// WEBPACK FOOTER //
// ./ecology9/wea-browser-search/style/index.js